import { r as redirect } from "../../../../chunks/index2.js";
const load = async ({ locals, route, cookies }) => {
  if (!locals.user && route.id !== "/(app)/portal/login") {
    throw redirect(302, "/portal/login");
  }
  return {
    user: locals.user
  };
};
export {
  load
};
